import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store/index";

/* (function() {
  const empty = () => {};
  console.log = empty;
  console.info = empty;
  console.debug = empty;
  console.warn = empty;
  console.error = empty;
})(); */


const nonce = document
  .querySelector("meta[name='csp-nonce']")
  ?.getAttribute("content");

if (nonce) {

  const addNonceToExistingStyles = () => {
    document.querySelectorAll("style:not([nonce])").forEach((el) => {
      el.setAttribute("nonce", nonce);
    });
  };

  addNonceToExistingStyles();


  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {

          if (node.tagName === "STYLE" && !node.hasAttribute("nonce")) {
            node.setAttribute("nonce", nonce);
          }

          if (node.querySelectorAll) {
            const styles = node.querySelectorAll("style:not([nonce])");
            styles.forEach((style) => {
              style.setAttribute("nonce", nonce);
            });
          }
        }
      });
    });
  });

  observer.observe(document.head, { 
    childList: true, 
    subtree: true 
  });
  
  observer.observe(document.body, { 
    childList: true, 
    subtree: true 
  });


  const originalCreateElement = document.createElement;
  document.createElement = function(tagName, options) {
    const element = originalCreateElement.call(this, tagName, options);
    if (tagName.toLowerCase() === "style") {
      element.setAttribute("nonce", nonce);
    }
    return element;
  };
}

window.store = store;


ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);